import { render, staticRenderFns } from "./CustomTodo.vue?vue&type=template&id=4c6b565a&scoped=true"
import script from "./CustomTodo.vue?vue&type=script&lang=js"
export * from "./CustomTodo.vue?vue&type=script&lang=js"
import style0 from "./CustomTodo.vue?vue&type=style&index=0&id=4c6b565a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6b565a",
  null
  
)

export default component.exports